import { render, staticRenderFns } from "./IngredientForCouverture.vue?vue&type=template&id=91f5c5a4"
import script from "./IngredientForCouverture.vue?vue&type=script&lang=js"
export * from "./IngredientForCouverture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports